import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css'
import { useCallback, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import httpService from '../../../../services/httpService';
import { ApiEndpoints, Constants } from '../../../../constants/appConstants';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useAuthContext } from '../../../../Context/AuthContext';
import { ReviewStatusCode } from '../../ProviderProfile/models';

import { Tooltip } from 'primereact/tooltip';
import { Calendar } from 'primereact/calendar';
import { FilterMatchMode, FilterOperator, FilterService } from 'primereact/api';
import { useAppContext } from '../../../../Context';
import MultipartFileUploadComponent from '../../../FileUpload/MultpartFileUploadComponent';
import { PfpRHKpiDashboardComponent } from './PfpRHKpiDashboardComponent';
import { getClientLocalDate, formatClientLocalDate } from '../../../../services/dateHelper';

FilterService.register('dateIs', (value: any, filter: any) => {
    if (filter === undefined || filter === null) {
        return true;
    }
    if (value === undefined || value === null) {
        return false;
    }
    const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
    const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
    
    if (!normalizedValue || !normalizedFilter) {
        return false;
    }
    return normalizedValue.getTime() === normalizedFilter.getTime();
});

FilterService.register('dateIsNot', (value: any, filter: any) => {
    if (filter === undefined || filter === null) {
        return true;
    }
    if (value === undefined || value === null) {
        return true;
    }
    const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
    const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
    
    if (!normalizedValue || !normalizedFilter) {
        return true;
    }
    return normalizedValue.getTime() !== normalizedFilter.getTime();
});


export const PfpRHProvidersComponent = () => {

    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [kpiData, setKpiData] = useState([]);

    const [IsActiveReview, setIsActiveReview] = useState(Boolean)
    const [kpiRefreshTrigger, setKpiRefreshTrigger] = useState(0);
    const [filteredData, setFilteredData] = useState(data);
    const [isLoading, setLoaing] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState<any>(null);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const globalSearchKeys = ['mpi', 'providerAgencyName', 'reviewStatus', 'currentTier'];
    const [visible, setVisible] = useState(false);
    const { isAdministrator } = useAuthContext();
    const [filters, setFilters] = useState<any>(null);
    const { reviewYear } = useAppContext();
    // api call onload
    useEffect(() => {
        if (reviewYear) {
            fetchAllProviders();
            setFilters({
                providerAgencyName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                mpi: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                reviewStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                reviewerName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                dateOfTierAssignment: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
                currentTier: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                tierChangeStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            });
        }
    }, [reviewYear])

    useEffect(() => {
        httpService.get(ApiEndpoints.IsActiveReview)
            .then((response: any) => {
                setIsActiveReview(response?.data)
            }).catch((error: any) => {
                console.log('Error: ', error);
            })
    }, [])

    const getDateOnly = (date: string) => {
        return getClientLocalDate(date);
    }

    const fetchAllProviders = () => {
        setLoaing(true);
        httpService.get(`${ApiEndpoints.GetAllProviders}/${reviewYear}`)
            .then((response: any) => {
                const updatedData = response?.data.map((item: any) => ({
                    ...item,
                    dateOfTierAssignment: getDateOnly(item.dateOfTierAssignment), // Convert string to Date object
                }));
                setData(updatedData);
                setFilteredData(updatedData);
                setKpiData(response?.data);
            }).catch((error: any) => {
                console.log('Error: ', error);
            }).finally(() => {
                // console.log('Finally');
                setLoaing(false);
            })
    }


    const parentSearchHandler = useCallback((value: any, searchColumns: string[]) => {

        let filtered = filteredData.filter((item: any) =>
            searchColumns.some((key) => {
                const fieldValue = String(item[key]).toLowerCase();
                return fieldValue.includes(value?.toLowerCase());
            })
        );
        if (value == globalFilterValue) {
            value = '';
            filtered = data;
        }
        setGlobalFilterValue(value);
        setFilteredData(filtered);
    }, [data]);

    const handleSearch = (e: any) => {

        let value = "";
        if (Array.isArray(e) && typeof (e.join('')) == "string") {
            value = e.join('');
        }
        else value = e.target.value;
        let filtered = data.filter((item: any) =>
            globalSearchKeys.some((key) => {
                const fieldValue = String(item[key]).toLowerCase();
                return fieldValue.includes(value?.toLowerCase());
            })
        );
        if (value == globalFilterValue) {
            value = '';
            filtered = data;
        }


        setGlobalFilterValue(value);
        setFilteredData(filtered);
    }

    const BeginReviewCycle = () => {
        httpService.get(ApiEndpoints.BeginReviewCycle)
            .then((response: any) => {
                if (response.status === 200) {
                    setIsActiveReview(true)
                    fetchAllProviders();
                    setKpiRefreshTrigger(prev => prev + 1);
                }
            })
    }

    const EndReviewCycle = () => {
        httpService.get(ApiEndpoints.EndReviewCycle)
            .then((response: any) => {
                if (response.status === 200) {
                    setIsActiveReview(false)
                }
            })
    }

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const confirmEndReview = () => {
        setShowConfirmDialog(true);
    };

    const onConfirmEndReview = () => {
        setShowConfirmDialog(false);
        EndReviewCycle();
    };

    const onCancelEndReview = () => {
        setShowConfirmDialog(false);
    };


    const onSelectedProviderChange = (e: any) => {
        console.log('onSelectChange', e)
        navigate(`/provider`, { state: { provider: e.value } });
        setSelectedProvider(e.value);
    }
    const renderHeader = () => {
        return (
            <div className="flex flex-wrap gap-2 justify-content-between ">
                <IconField iconPosition="left" style={{ alignItems: 'end' }}>
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={handleSearch} placeholder="Search Provider" />
                </IconField>
            </div>
        );
    };
    const showDateOfTierAssignment = (rowData: any) => {
        if (rowData.dateOfTierAssignment) {
            return formatClientLocalDate(rowData.dateOfTierAssignment);
        }
    }
    const getKpiIsEnabled = () => Constants.KPI_IS_ENABLED;

    const tierChangeStatusTemplate = (rowData: any) => {
        let status = rowData.tierChangeStatus;
        return (
            status && status.toLowerCase() === 'yes' ?
                <div className="flex">
                    <span style={{ paddingRight: "5px" }}>{status}</span>
                    <Tooltip target=".status" />
                    <i
                        className="pi pi-info-circle status"
                        data-pr-tooltip={"Previous Tier: " + (rowData.previousTier || 'Not Available')}
                        data-pr-position="top"
                        style={{ alignContent: "center" }}
                    />
                </div>
                :
                status
        );
    }

    const dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value} onChange={(e) => {
    const selectedDate = e.value;
    if (selectedDate) {
        const clientDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0);
        options.filterCallback(clientDate, options.index);
    } else {
        options.filterCallback(null, options.index);
    }
}} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
    };

    const header = renderHeader();
    return (
        <>
            {/* <MegaMenu model={navigationItems} breakpoint='960px' /> */}
            <div className="card">
                <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '10px', padding: '15px 25px', height: '80px', minHeight: '5rem', }}>
                    {isAdministrator() &&
                        <>
                            <Button size='small' className="p-button-secondary" onClick={() => navigate(`/standards`)}>
                                Performance Standards
                            </Button >
                            {IsActiveReview == false ?
                                <Button size='small' className="p-button-secondary" onClick={() => BeginReviewCycle()}>
                                    Begin Review Cycle
                                </Button> :
                                <Button size='small' className="p-button-secondary" onClick={() => confirmEndReview()}>
                                    End Review Cycle
                                </Button>
                            }

                        </>
                    }
                    {IsActiveReview == false ?
                        <Button size='small' className="p-button-secondary" //style={{ cursor: 'pointer', backgroundColor: '#007acc', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', whiteSpace: 'pre-line' }}
                            onClick={() => setVisible(true)} >
                            Upload File
                        </Button> :
                        <Button size='small' className="p-button-secondary" //style={{ cursor: 'pointer', backgroundColor: '#007acc', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', whiteSpace: 'pre-line' }}
                            onClick={() => setVisible(true)} >
                            Upload CLS Data
                        </Button>
                    }
                </div>

                <div className="kpi-pie-chart-wrapper">
                    {getKpiIsEnabled() && <PfpRHKpiDashboardComponent
                        key={kpiRefreshTrigger}
                        providersData={kpiData}
                        searchHandler={parentSearchHandler}
                    />}
                </div>


                <Dialog
                    header="Upload"
                    visible={visible}
                    onHide={() => setVisible(false)}
                ><div className="flex flex-column px-8 py-5 gap-4" style={{ borderRadius: '12px', width: '1000px', height: 'auto', minHeight: '300px' }}>
                        <MultipartFileUploadComponent allowedExtension="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" maxSize={100000}
                            onFileuploaded={() => { fetchAllProviders() }} />
                    </div>
                    <div>
                        <p style={{ textAlign: "center" }}>click <a style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => navigate(`/Upload`)} >
                            here</a> to view status of uploaded files
                        </p>
                    </div>
                </Dialog>

                {/* End review cycle confirmation popup */}
                <Dialog
                    header="Confirmation"
                    visible={showConfirmDialog}
                    onHide={onCancelEndReview}
                    footer={
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                            <Button label="No" icon="pi pi-times" onClick={onCancelEndReview} className="p-button-text" />
                            <Button label="Yes" icon="pi pi-check" onClick={onConfirmEndReview} autoFocus />
                        </div>
                    }
                >
                    <div>
                        {data.some((provider: any) => provider.reviewStatusCode?.toLowerCase() !== ReviewStatusCode.ReviewCompleted?.toLowerCase()) && (
                            <p style={{ color: 'red' }}>Some providers' reviews are not yet completed.</p>
                        )}
                        <p>Are you sure you want to <b>End the review cycle</b>?</p>
                    </div>
                </Dialog>


                <div>
                    <DataTable value={filteredData} paginator header={header} rows={5} rowsPerPageOptions={[5, 10, 25, 50]} loading={isLoading}
                        filters={filters} selectionMode="single" selection={selectedProvider} onSelectionChange={onSelectedProviderChange} dataKey="providerId" emptyMessage="No provider found."
                    >

                        <Column field="providerAgencyName" header="Provider Agency Name" sortable filter filterPlaceholder="Filter by Agency Name" style={{ minWidth: '14rem' }} />
                        <Column field="mpi" header="MPI" sortable filter filterPlaceholder="Filter by Agency Name" style={{ minWidth: '14rem' }} />
                        <Column field="reviewStatus" header="Status" sortable filter filterPlaceholder="Filter by Agency Status" style={{ minWidth: '14rem' }} />
                        <Column field="reviewerName" header="Reviewer" sortable filter filterPlaceholder="Filter by Tier Change Status" style={{ minWidth: '14rem' }} />
                        <Column field="dateOfTierAssignment" header="Date of Tier Assignment" sortable filter
                            dataType="date"
                            filterElement={dateFilterTemplate}
                            filterPlaceholder="Filter by Date of Tier Assignment" style={{ minWidth: '14rem' }} body={(rowData) => showDateOfTierAssignment(rowData)} />
                        <Column field="currentTier" header="Current Tier" sortable filter filterPlaceholder="Filter by Tier" style={{ minWidth: '14rem' }} />
                        <Column field="tierChangeStatus" header="Tier Change Status" body={tierChangeStatusTemplate} sortable filter filterPlaceholder="Filter by Tier Change Status" style={{ minWidth: '14rem' }} />
                    </DataTable>
                </div>

            </div >
        </>
    )
}